import React from "react";
import "./_template-video.scss";

function CardVideo({ url, title }) {
  return (
    <div
      className="col-12 col-md-6 col-lg-4"
      data-aos="fade-up"
      data-aos-duration="700"
    >
      <div className="card card-body">
        <div className="w-full bg-red-300">
          <iframe
            className="w-full h-[462px] mx-auto"
            src={url}
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <div className="btn">
          Kode UR:
          <br />
          {title}
        </div>
      </div>
    </div>
  );
}

export default CardVideo;
